/* =========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

export default [
  {
    url: '/menu',
    icon: 'HomeIcon',
    i18n: 'Devices'
  },
  {
    url: '/dashboard',
    icon: 'ActivityIcon',
    i18n: 'Dashboard'
  },
  {
    url: '/map',
    icon: 'MapIcon',
    i18n: 'Map'
  },
  {
    url: '/users',
    icon: 'UserIcon',
    i18n: 'Users',
    role: 'MA'
  }
]
